<template lang="pug">
.v-article.article(v-if="article")
	.article__container.container
		.article__wrap
			.article__left(v-if="!isMd")
				.article__info-wrap
					.article__background
					.article__title(v-if="article.title")
						v-svg-icon.article__title-icon(icon="flower")
						h2.article__title-text {{article.title}}
					.article__navigation-list(v-if="article.items && article.items.length")
						template(v-for="(item, index) in article.items" :key="index")
							button.article__navigation-item.flc(type="button" :class="{'active': index === activeIndex}" @click="goToItem(index)") {{item.title}}
					.article__widget(v-if="article.widget")
						v-link-widget(:widget="article.widget")
			.article__right(v-if="article.text || article.items")
				.article__content
					.article__text.text-guide(v-if="article.text" v-html="article.text")
					.article__items.flc(v-if="article.items && article.items.length")
						template(v-for="(item, index) in article.items" :key="index")
							.article__item.text-guide.flc(:ref="'item' + index")
								h2.h2.article__item-title(v-if="item.title") {{item.title}}
								.article__item-text(v-if="item.text" v-html="item.text")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			article: null,
			activeIndex: 0
		};
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		goToItem(index) {
			let $targetItem = this.$refs['item' + index];
			let offset = 40;
			window.scrollTo({
				top: this.$el?.offsetTop + $targetItem[0].offsetTop - offset,
				behavior: 'smooth'
			});
		},

		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				// document.body.classList.add('state--page-header-blackout');
				if (!this.isMd) {
					this.article.items.forEach((item, index) => {
						let $currentItem = this.$refs['item' + index];
						if ($currentItem) {
							if (this.$el?.offsetTop + $currentItem[0].offsetTop - window.scrollY - window.innerHeight + (window.innerHeight / 2) < 0) {
								this.activeIndex = index;
							}
						}
					});
				}
			}
		},

		dataSet(data) {
			this.article = data;
			this.handleScroll();
			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
